import { useState } from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useStore } from '../stores/store';
import { BRAND } from '../theme';
import logoNavy from '../assets/fpi-logo-navy.svg';

export function LoginView() {
	const login = useStore((s) => s.login);
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const [error, setError] = useState('');
	const [loading, setLoading] = useState(false);

	async function submit(e: React.FormEvent) {
		e.preventDefault();
		if (loading) return;
		setError('');
		setLoading(true);
		try {
			await login(username.trim(), password);
		} catch {
			setError('Incorrect username or password');
			setPassword('');
		} finally {
			setLoading(false);
		}
	}

	return (
		<Box
			sx={{
				position: 'fixed',
				inset: 0,
				background: `linear-gradient(135deg, ${BRAND.navy} 0%, #0f1722 100%)`,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				p: 2.5,
				zIndex: 1000,
			}}
		>
			<Paper sx={{ borderRadius: 3.5, p: 4, width: '100%', maxWidth: 380, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
				<Box
					component="img"
					src={logoNavy}
					alt="Future Pipe Industries"
					sx={{ height: 38, width: 'auto', display: 'block', mx: 'auto', mb: 2 }}
				/>
				<Typography sx={{ textAlign: 'center', fontSize: 18, fontWeight: 700, color: BRAND.navy, mb: 0.5 }}>
					Pipe Location Tracker
				</Typography>
				<Typography sx={{ textAlign: 'center', fontSize: 12, color: 'text.secondary', mb: 3 }}>
					PT Future Pipe Industries Indonesia
				</Typography>
				<form onSubmit={submit}>
					<TextField
						label="Username"
						value={username}
						onChange={(e) => setUsername(e.target.value)}
						placeholder="admin or operator"
						autoComplete="username"
						sx={{ mb: 2 }}
					/>
					<TextField
						label="Password"
						type="password"
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						placeholder="Password"
						autoComplete="current-password"
						sx={{ mb: 1.5 }}
					/>
					{error && (
						<Typography sx={{ color: 'error.main', fontSize: 12, mb: 1.25, fontWeight: 600 }}>✗ {error}</Typography>
					)}
					<Button type="submit" variant="contained" fullWidth disabled={loading} sx={{ py: 1.5, fontSize: 14 }}>
						{loading ? 'Signing in…' : 'Sign In'}
					</Button>
				</form>
			</Paper>
		</Box>
	);
}
